import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Program_inquiry = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 탐구(사회/역사)`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/program_learning">두뇌 톡톡</a>
              </li>
              <li>
                <a href="/program_language">언어 톡톡</a>
              </li>
              <li>
                <a href="/program_inquiry" className="sel">
                  탐구(사회/역사)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="program_inquiry process">
          <div className="sect process01 inquiry01">
            <div className="wrap">
              <div className="tit-wrap">
                <div className="tit init">창의 융합형 교재</div>
                <div className="txt init">
                  누리 교육과정과 초등 교육과정의 다리역할!
                </div>
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_process_inquiry01_img.png"
                  className="pc-view"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_process_inquiry01_img_ver2023_mo.png"
                  className="mo-view"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process02 inquiry02">
            <div className="wrap">
              <div className="tit init">
                탐구 학습의 유기농공부로 <br className="mo-view" />
                <br />
                통합 탐구 영역의 경쟁력을 키워요!{" "}
              </div>
              <div className="txt init">
                <p>
                  <span className="neon init">
                    누리 교육과정의 놀이중심 5개의 영역
                  </span>
                  과 <br className="mo-view" />
                  <span className="neon init">
                    초등 교육과정의 사회과학 교과영역
                  </span>
                  의 <br className="pc-view" />
                  다리 역할을 하는 학습으로 <br className="mo-view" /> 탄탄한
                  탐구 학습 방법을 알려 줍니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect process03 inquiry03">
            <div className="wrap">
              <div className="tit init">
                <img
                  src="../custom-resources/img/img_process_inquiry02_img01.png"
                  alt=""
                />
              </div>
              <div className="prs">
                <ul>
                  <li className="init">
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_inquiry02_img02.png"
                        alt=""
                      />
                    </div>
                    <div className="txt">
                      초등 교과의 사회 과학적 지식을 <br className="mo-view" />
                      아이들의 눈높이에 맞게 경험하는 교재로
                      <br />
                      국어, 사회, 과학, 인성이 통합된
                      <br className="mo-view" /> 창의 융합형 탐구 프로그램
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect process04 inquiry04">
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry03_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  글을 읽기 시작하는 단계의 어린이들이 알아야 할
                  <br className="mo-view" /> 사회과학 지식을 재미있게 습득하도록
                  <br className="mo-view" /> 그림 이야기를 통해 흥미를 제공하여{" "}
                  <br className="mo-view" />
                  자기주도학습이 이루어지도록 합니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img04.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-03 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img05.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-04 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img06.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-05 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img07.png"
                      alt=""
                    />
                  </div>
                  <div className="img book01-img-06 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry03_img08.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry04_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  사회과학 지식의 주제와 연계된 과학 내용 지식을
                  <br className="mo-view" /> 관찰, 측정, 분류, 예상, 추리,
                  의사소통 등<br className="mo-view" /> 탐구의 기능을 활용하여
                  <br className="mo-view" /> 과학적인 태도와 호기심을 키웁니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry04_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book02-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry04_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book02-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry04_img04.png"
                      alt=""
                    />
                  </div>
                  <div className="img book02-img-03 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry04_img05.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry05_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  사회과학 지식을 감성적 체험을 통해 <br className="mo-view" />
                  심화 시킬 수 있도록 <br className="mo-view" />
                  인성융합수업으로 구성하였습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry05_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book03-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry05_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book03-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry05_img04.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry06_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  다양한 예술적 경험 수업을 위해 <br className="mo-view" />
                  실제 생활에서 가장 가까이 쉽게 접할 수 있는{" "}
                  <br className="mo-view" />
                  종이를 활용하여 스스로 놀이하며 <br className="mo-view" />
                  사회과학 지식을 융합 할 수 있습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry06_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book04-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry06_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book04-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry06_img04.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sect process05 inquiry05">
            <div className="wrap">
              <div className="tit">
                <img
                  src="../custom-resources/img/img_process_inquiry07_img01.png"
                  alt=""
                />
              </div>
              <div className="prs">
                <ul>
                  <li className="init">
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_inquiry07_img02.png"
                        alt=""
                      />
                    </div>
                    <div className="txt">
                      한국사 지식을 아이들의 눈높이에 맞게{" "}
                      <br className="mo-view" />
                      학습하는 교재로 <br className="pc-view" />
                      <br className="mo-view" />
                      국어, 역사, 과학, 조형, 인성이 통합된{" "}
                      <br className="mo-view" /> 창의 융합형 탐구 프로그램
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect process06 inquiry06">
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry08_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  옛 사람들의 삶과 문화를 알아보는 글을{" "}
                  <br className="mo-view" />
                  SQ3R 읽기능력 훈련 방법으로 <br className="mo-view" />
                  보다 정확하고 빠르게 이해하도록 수정하였습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img04.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-03 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img05.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-04 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img06.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-05 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img07.png"
                      alt=""
                    />
                  </div>
                  <div className="img book05-img-06 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry08_img08.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry09_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  주제와 연계된 과학 내용 지식을 <br className="mo-view" />
                  관찰, 측정, 분류, 예상, 추리, 의사소통 등{" "}
                  <br className="mo-view" />
                  탐구의 기능을 활용하여 <br className="mo-view" />
                  과학적인 태도와 호기심을 기를 수 있습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry09_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book06-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry09_img03.png"
                      alt=""
                    />
                  </div>
                  <div className="img book06-img-02 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry09_img04.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry10_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  초등 교육과정 한국사 관련 지식을 <br className="mo-view" />
                  감성적 체험을 통해 심화하도록 <br className="mo-view" />
                  인성융합수업으로 구성하였습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry10_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book07-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry10_img03.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap">
              <div className="txt">
                <div className="tit init">
                  <img
                    src="../custom-resources/img/img_process_inquiry11_img01.png"
                    alt=""
                  />
                </div>
                <div className="sub-tit init">
                  다양한 예술적 경험 융합 수업을 위해 실제 생활에서{" "}
                  <br className="mo-view" />
                  가장 가까이 쉽게 접할 수 있는 종이를 활용하여{" "}
                  <br className="mo-view" />
                  스스로 놀이하며 한국사 지식을 융할 할 수 있습니다.
                </div>
              </div>
              <div className="book-wrap">
                <div className="img-book">
                  <div className="book init">
                    <img
                      src="../custom-resources/img/img_process_inquiry11_img02.png"
                      alt=""
                    />
                  </div>
                  <div className="img book08-img-01 init">
                    <img
                      src="../custom-resources/img/img_process_inquiry11_img03.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sect process07 inquiry07">
            <div className="wrap">
              <div className="tit init">
                탐구 영역의 학습생명력을 키우는 프로그램!
              </div>
              <div className="bg-img">
                <img
                  src="../custom-resources/img/img_process_inquiry12_img01.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Program_inquiry;
